/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitTablesTableBody.module.scss';

const TableBody = forwardRef(({ children = null, className = '', testId = '' }, ref) => (
  <tbody
    className={classnames(styles.element, className)}
    data-testid={testId}
    ref={ref}
  >
    {children}
  </tbody>
));

TableBody.displayName = 'TableBody';

TableBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default TableBody;
